import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import ProductInformationTabs from '../Components/ProductInformationTabs';
import ProductInformationAccordion from '../Components/ProductInformationAccordion';

const ProductPageTabsContainer = (props) => {
  const IsLargeScreen = useMediaQuery('(min-width:1024px)'); //Accordion for 1024 and smaller, tabs for larger

  return (
    <>
      {IsLargeScreen ? (
        <ProductInformationTabs {...props} />
      ) : (
        <ProductInformationAccordion {...props} />
      )}
    </>
  );
};

export default ProductPageTabsContainer;
